export const init = () => {
    const observer = new MutationObserver(() => {
        if (document.querySelector('.js-accordion-self-basic')) {
            let activeTargets = document.querySelectorAll('.js-accordion-self-basic:not([data-js-applied="true"])');
    
            activeTargets.forEach(function (cur) {
                let showAccordionFrom = cur.dataset.accordionFrom
    
                if (window.screen.width < Number(showAccordionFrom)) {
                    return;
                }
    
                cur.addEventListener('click', function () {
                    let contentWrapper = cur.querySelector('.content-wrapper');
                    cur.classList.toggle('active');
                    let animationAllHeight = 0;
    
                    for (var i = 0; i < contentWrapper.children.length; i++) {
                        var childElement = contentWrapper.children[i];
    
                        animationAllHeight += childElement.offsetHeight + 25;
                    }
    
                    if (cur.classList.contains('active')) {
                        contentWrapper.style.maxHeight = animationAllHeight + 24 + 24 + 'px';
                    } else {
                        contentWrapper.removeAttribute('style');
                    }
                }); 
                cur.dataset.jsApplied = true;
            })
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};
